// frontend/src/features/livestock/pickerThumbSize.ts
// How big the organisms' pictures are in the assign view's list on a
// computer: rows with a small or a medium picture, or a grid of large tiles
// for picking a coral out by eye when its name doesn't come to mind. Kept in
// localStorage; without it (private mode, blocked site data) the choice lasts
// as long as the page. Phones always show small rows.

export type PickerThumbSize = 'small' | 'medium' | 'large';

export const PICKER_THUMB_SIZES: { value: PickerThumbSize; label: string }[] = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
];

export const DEFAULT_PICKER_THUMB_SIZE: PickerThumbSize = 'medium';

const STORAGE_KEY = 'rdh-photo-inbox-thumb-size';

let memory: PickerThumbSize | null = null;

function isSize(value: unknown): value is PickerThumbSize {
  return PICKER_THUMB_SIZES.some((size) => size.value === value);
}

export function readPickerThumbSize(): PickerThumbSize {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isSize(stored)) return stored;
  } catch {
    // No storage: the choice made on this page, if any.
  }
  return memory ?? DEFAULT_PICKER_THUMB_SIZE;
}

export function writePickerThumbSize(size: PickerThumbSize): void {
  memory = size;
  try {
    localStorage.setItem(STORAGE_KEY, size);
  } catch {
    // Kept in memory only.
  }
}

/** For tests: forget a choice kept in memory. */
export function resetPickerThumbSizeMemory(): void {
  memory = null;
}
